import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { RoleService } from './common/role-service';

const isAccessAllowed = async (
  state: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated } = authData;

  if (authenticated) {
    const router = inject(Router);
    const roleService = inject(RoleService);
    const requiredRoles = (state.data?.['roles'] as string[])?.join(',') ?? '';
    console.log('required roles',requiredRoles);
    console.log(state.pathFromRoot.map(route => route.url.map(segment => segment.toString()).join('/')).join('/'));
    if (!roleService.hasRole(requiredRoles)) {
      return router.parseUrl('/deny-access');
    }
    return true;
  } else {
    const keycloak = inject(Keycloak);
    const url = location.href;
    await keycloak.login({ redirectUri: url });
    return false;
  }
};
export const authGuard: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed);
